"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isArray = require("lodash/isArray");

var _isArray2 = _interopRequireDefault(_isArray);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

require("react-select/dist/react-select.css");

var _reactSelect = require("react-select");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.handleChange = function (selected) {
            var value = '';
            var _this$props = _this.props,
                name = _this$props.name,
                onChange = _this$props.onChange;


            if ((0, _isArray2.default)(selected)) {
                value = selected.map(function (selected) {
                    return selected.value;
                });
            } else if (selected && selected.value) {
                value = selected.value;
            }

            _this.setState({ value: selected }, function () {
                return onChange({ name: name, value: value });
            });
        };

        _this.shouldKeyDownEventCreateNewOption = function (_ref) {
            var keyCode = _ref.keyCode;

            return [9, 13, _this.props.tags ? 188 : ''].indexOf(keyCode) != -1; // Create new options only on tab and enter
        };

        _this.state = {
            value: props.defaultValue || ''
        };
        return _this;
    }

    _createClass(Select, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(props) {
            if (props.value !== this.props.value) {
                this.setState({ value: props.value });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                options = _props.options,
                name = _props.name,
                onChange = _props.onChange,
                labelProps = _props.labelProps,
                error = _props.error,
                creatable = _props.creatable,
                tags = _props.tags,
                rest = _objectWithoutProperties(_props, ["options", "name", "onChange", "labelProps", "error", "creatable", "tags"]);

            var Component = creatable || tags ? _reactSelect.Creatable : _reactSelect2.default;

            return _react2.default.createElement(
                "div",
                null,
                labelProps.label && _react2.default.createElement(
                    _label2.default,
                    _extends({ name: name }, labelProps),
                    labelProps.label
                ),
                " ",
                _react2.default.createElement(Component, _extends({
                    options: options.map(function (option) {
                        return { value: option.value, label: option.text };
                    }),
                    value: this.state.value,
                    onChange: this.handleChange,
                    shouldKeyDownEventCreateNewOption: this.shouldKeyDownEventCreateNewOption
                }, rest)),
                _react2.default.createElement(_inputError2.default, { error: error })
            );
        }
    }]);

    return Select;
}(_react2.default.Component);

Select.displayName = "Select";

Select.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any,
        text: _propTypes2.default.string.isRequired
    })),
    labelProps: _propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired
    }),
    placeholder: _propTypes2.default.string,
    multi: _propTypes2.default.bool,
    creatable: _propTypes2.default.bool,
    tags: _propTypes2.default.bool,
    error: _propTypes2.default.string
};

Select.defaultProps = {
    error: '',
    labelProps: {
        label: ''
    }
};

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/select.js
// module id = 1006
// module chunks = 95715928098905 168707334958949